export const GUIDE_WELCOMESTEP_TEXT = 'Portal_Velkomst_Melding_NyeBrukere'

export const COOPERATIVESCHOOL_TEXT = 'Boligbyggelaget_Styreskolen_Info'
export const COOPERATIVE_LEGAL_TALK_TEXT = 'Boligbyggelaget_Borettslaget_info'

export const HOUSINGCOOPERATIVE_COURSES_TEXT = 'Boligbyggelaget_Kurs'
export const HOUSINGCOOPERATIVE_GUIDANCE_TEXT = 'Boligbyggelaget_Veiledning'

export const INVOICEAPPROVAL_LIST = 'Portal_fakturagodkjenning_liste_ingress'

export const DASHBOARD_ACCOUNTS = 'Okonomi_Oversikt_Bankkonto'
export const DASHBOARD_LOANS = 'Okonomi_Oversikt_Lan'
export const DASHBOARD_JOINTCOST = 'Okonomi_Oversikt_Felleskostnader'
export const DASHBOARD_UNPAIDINVOICES = 'Okonomi_Oversikt_Ubetaltfaktura'
export const DASHBOARD_AVAILABLEFUNDS = 'Okonomi_Oversikt_Disponiblemidler'
export const DASHBOARD_AVAILABLEFUNDS_WORKINGCAPITAL =
  'Okonomi_Oversikt_Arbeidskapital'
export const DASHBOARD_OPERATINGCOST = 'Okonomi_Oversikt_Driftskostnader'
export const DASHBOARD_RESULTS = 'Okonomi_Oversikt_Resultatdiagram'

export const PRIVACY_STATEMENT_MODAL_TEXT =
  'Personvern_informasjonskapsler_info'

export const DIGITAL_KEYS_TEXT = 'DigitaleNokler_Ingress'

export const SIGNATURE_INFO =
  'KommunikasjonInnstillinger_StandardSignatur_Ingress'

export const CASHFLOW_INFO = 'Okonomi_Oversikt_Kontantstrom'

export const HOME_INTEREST_CHANGED_TEXT = 'Hjem_Renteendring_laan'

export const APPROVE_NEW_OWNER_REJECTED = 'Oppgave_Godkjenning_av_ny_eier_Avvis'
export const APPROVE_NEW_OWNER_FOR_APPROVAL =
  'Oppgave_Godkjenning_av_ny_eier_til_godkjenning'
export const APPROVE_NEW_OWNER_FOR_INFO =
  'Oppgave_Godkjenning_av_ny_eier_til_informasjon'
export const APPROVE_NEW_OWNER_BBL = 'Oppgave_Godkjenning_av_ny_eier_BBL'

export const INSURANCE_AGREEMENT_LIST_CLAIM_INSURANCE =
  'Forsikring_Liste_Meld_Skade_Infotekst_Avtale'
export const INSURANCE_RULES = 'Forsikring_Regler'
export const BUDGET_INFORMATION = 'Budsjett_informasjon'

export const BUDGET_SELF_SERVICE_INFORMATION =
  'Budsjett_Selvbetjening_Informasjon'
export const BUDGET_HELP_ORDER_LINK = 'Budsjett_Bistand_Bestilling_Url'
export const BUDGET_HELP_INFORMATION = 'Budsjett_Bistand_Informasjon'
export const BUDGET_DEPARTMENT_BUDGET_INFO = 'Budsjett_Avdelingsbudsjett'

export const BEVAR_HMS_SALES_TEXT = 'Bevar_hms_innsalgsside'
export const BEVAR_VEDLIKEHOLD_SALES_TEXT = 'Bevar_vedlikehold_innsalgsside'

export const RABATTAVTALER = 'Rabattavtaler_Informasjon'

export const Unloc_Innsalgstekst_Ingress = 'Unloc_Innsalgstekst_Ingress'
export const Unloc_Bestilling_Url = 'Unloc_Bestilling_Url'
export const Unloc_Inaktiv_Avtale_Sporsmal_1 = 'Unloc_Inaktiv_Avtale_Sporsmal_1'
export const Unloc_Inaktiv_Avtale_Sporsmal_2 = 'Unloc_Inaktiv_Avtale_Sporsmal_2'
export const Unloc_Inaktiv_Avtale_Sporsmal_3 = 'Unloc_Inaktiv_Avtale_Sporsmal_3'
export const Unloc_Inaktiv_Avtale_Svar_1 = 'Unloc_Inaktiv_Avtale_Svar_1'
export const Unloc_Inaktiv_Avtale_Svar_2 = 'Unloc_Inaktiv_Avtale_Svar_2'
export const Unloc_Inaktiv_Avtale_Svar_3 = 'Unloc_Inaktiv_Avtale_Svar_3'
export const Unloc_Aktiv_Avtale_Ingress = 'Unloc_Aktiv_Avtale_Ingress'
export const REIMBURSEMENT_REGISTRATION_TEXT = 'Okonomi_Utlegg_Registrering'
export const REIMBURSEMENT_RECEIPT_TEXT = 'Okonomi_Utlegg_Kvittering'

export const MEETINGS_INTRO_TEXT = 'Kundemoete_avtal_moete'

export const Really_Innsalgstekst_Ingress = 'Really_Innsalgstekst_Ingress'
export const Really_Bestilling_Url = 'Really_Bestilling_Url'
export const Really_Inaktiv_Avtale_Sporsmal_1 =
  'Really_Inaktiv_Avtale_Sporsmal_1'
export const Really_Inaktiv_Avtale_Sporsmal_2 =
  'Really_Inaktiv_Avtale_Sporsmal_2'
export const Really_Inaktiv_Avtale_Sporsmal_3 =
  'Really_Inaktiv_Avtale_Sporsmal_3'
export const Really_Inaktiv_Avtale_Svar_1 = 'Really_Inaktiv_Avtale_Svar_1'
export const Really_Inaktiv_Avtale_Svar_2 = 'Really_Inaktiv_Avtale_Svar_2'
export const Really_Inaktiv_Avtale_Svar_3 = 'Really_Inaktiv_Avtale_Svar_3'

/// ÅRSMØTE ///////////////////////////////////////////////////////////////////////////////
export const Styrearbeid_Aarsmoete_Hva_er_aarsmoete =
  'Styrearbeid_Aarsmoete_Hva_er_aarsmoete'
export const Styrearbeid_Generalforsamling_Borettslag_Hva_er_generalforsamling =
  'Styrearbeid_Generalforsamling_Borettslag_Hva_er_generalforsamling'
export const Styrearbeid_Generalforsamling_Aksje_Hva_er_generalforsamling =
  'Styrearbeid_Generalforsamling_Aksje_Hva_er_generalforsamling'
export const Styrearbeid_Aarsmoete_Hva_er_ekstraordinaert_aarsmoete =
  'Styrearbeid_Aarsmoete_Hva_er_ekstraordinaert_aarsmoete'
export const Styrearbeid_Generalforsamling_Borettslag_Hva_er_ekstraordinaer_generalforsamling =
  'Styrearbeid_Generalforsamling_Borettslag_Hva_er_ekstraordinaer_generalforsamling'
export const Styrearbeid_Generalforsamling_Aksje_Hva_er_ekstraordinaer_generalforsamling =
  'Styrearbeid_Generalforsamling_Aksje_Hva_er_ekstraordinaer_generalforsamling'

// ÅRSMØTE BISTAND ///////////////////////////////////////////////////////////////////////////////
export const Styrearbeid_Generalforsamling_Aksje_Bistand =
  'Styrearbeid_Generalforsamling_Aksje_Bistand'
export const Styrearbeid_Generalforsamling_Borettslag_Bistand =
  'Styrearbeid_Generalforsamling_Borettslag_Bistand'
export const Styrearbeid_Aarsmoete_Bistand = 'Styrearbeid_Aarsmoete_Bistand'

// ÅRSMØTE TJENESTER ///////////////////////////////////////////////////////////////////////////////
export const Styrearbeid_Generalforsamling_Aksje_Tjenester =
  'Styrearbeid_Generalforsamling_Aksje_Tjenester'
export const Styrearbeid_Generalforsamling_Borettslag_Tjenester =
  'Styrearbeid_Generalforsamling_Borettslag_Tjenester'
export const Styrearbeid_Aarsmoete_Tjenester = 'Styrearbeid_Aarsmoete_Tjenester'
